/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentsListResponse } from '../../models/attachments-list-response';
import { BaseResponse } from '../../models/base-response';

export interface AttachmentsControllerGetAll$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  query?: string;
  order_by?: 'type_description' | 'on_duplication' | 'max_size_mb';
  order_direction?: 'asc' | 'desc';
}

export function attachmentsControllerGetAll(http: HttpClient, rootUrl: string, params: AttachmentsControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AttachmentsListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, attachmentsControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('query', params.query, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AttachmentsListResponse;
      }>;
    })
  );
}

attachmentsControllerGetAll.PATH = '/attachments';
